export default __webpack_public_path__ + "static/media/background_book@2x.77fb2eac.jpg";